import OcrListingLegacyMapping from 'vcomponents/listing/apiListing/mapping/OcrListingLegacyMapping.js';

export default [
    {
        id: "ocr",
        label: window.i18n.__("Documents en attente de vérification"),
        buttons: [],
        enableExport: false,
        enableKpisOnExport: false,
        enableFiltering: false,
        enableOptions: false,
        enableContext: false,
        endpoint: '',
        exportOptions: {},
        favorite: null,
        filter: {},
        filtersComponent: undefined,
        linkedtype: "ocr",
        name: "ocr",
        params: {},
        prefilter: {},
        savedSearchesUrl: "",
        switchDisplay: [],
        url: "ocr/pur-invoice/search",
        exportUrl: "",
        metaUrl: "ocr/pur-invoice/metas",
        useFavorites: false,
        group: 'ocr',
        favoritesName: 'ocr',
        emptyResultPlaceholder: window.i18n.__('Vous n\'avez aucun document en attente de vérification'),
        listingMapping: OcrListingLegacyMapping,
    },
]
